@if (lesson | async; as lesson) {
  <ng-container class="lesson">
    <header class="lesson-header">
      <div>
        <h1>Identification, Strategy and Hypothesis</h1>
        <p>{{lesson.hypothesisCopy}}</p>
      </div>
    </header>
    <section class="lesson-content">
      <div class="lesson-problem">
        @if (lesson.problem.content) {
          <app-content-viewer  [content]=lesson.problem.content></app-content-viewer>
        }
        @if (utilitiesService.problemHasContentPassage(lesson.problem)) {
          <div class="lesson-passage" >
            @if (lesson.problem.passage) {
              <app-content-viewer [content]=lesson.problem.passage.content></app-content-viewer>
            }
          </div>
        }
      </div>
      <div class="lesson-answers">
        <h3>{{lesson.hypothesisPrompt}}</h3>
        <form>
          <textarea class="form-control" title="hypothesis" [formControl]="hypothesisForm.get('hypothesis')"></textarea>
          @if (formService.controlHasError( hypothesisForm.get('hypothesis'), 'required')) {
            <div
              class="form-control-feedback">Hypothesis is required
            </div>
          }
          <button class="btn btn-primary btn-lg btn-block" (click)="handleOnSubmit()" required>Make Hypothesis</button>
        </form>
        <ng-template #loading2>
          <app-spinner></app-spinner>
        </ng-template>
      </div>
    </section>
  </ng-container>
} @else {
  <app-spinner></app-spinner>
}

